(function () {
  function setupMarquee(marquee) {
    var track = marquee.querySelector('[data-as-seen-on-track]');
    var firstGroup = marquee.querySelector('[data-as-seen-on-group]');
    if (!track || !firstGroup) return;

    if (track.getAttribute('data-as-seen-on-ready') === 'true') return;

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var targetWidth = viewportWidth * 2;

    var groupWidth = firstGroup.getBoundingClientRect().width;

    if (groupWidth === 0) {
      window.requestAnimationFrame(function () {
        setupMarquee(marquee);
      });
      return;
    }

    var totalWidth = groupWidth;
    while (totalWidth < targetWidth) {
      var clone = firstGroup.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      totalWidth += groupWidth;
    }

    track.style.setProperty('--as-seen-on-group-width', groupWidth + 'px');
    track.setAttribute('data-as-seen-on-ready', 'true');
  }

  function init() {
    var marquees = document.querySelectorAll('[data-as-seen-on-marquee]');
    marquees.forEach(function (marquee) {
      window.requestAnimationFrame(function () {
        setupMarquee(marquee);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      document.querySelectorAll('[data-as-seen-on-track]').forEach(function (track) {
        track.setAttribute('data-as-seen-on-ready', 'false');
        var groups = track.querySelectorAll('[data-as-seen-on-group]');
        groups.forEach(function (g, i) {
          if (i > 0) g.remove();
        });
      });
      init();
    }, 250);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var marquee = event.target.querySelector('[data-as-seen-on-marquee]');
    if (marquee) {
      var track = marquee.querySelector('[data-as-seen-on-track]');
      if (track) track.setAttribute('data-as-seen-on-ready', 'false');
      window.requestAnimationFrame(function () {
        setupMarquee(marquee);
      });
    }
  });
})();
